const optionsData = [
  {
    title: 'UGC Service Experience',
    monthlyPrice: '100 USD',
    annualPrice: '280 USD',
    duration: 'Mensual',
    features: [
      'Un video semanal.',
      'Video dinámico tipo "Solución en sitio" (mantenimiento, remodelación, servicios).',
      'Demostración real del producto/servicio en un entorno de edificio o condominio.',
      'Narrativa enfocada en la resolución de problemas comunes.',
      'Archivo optimizado para las redes sociales de la marca.',
    ],
    idealFor: 'Empresas de impermeabilización, seguridad, ascensores, pintura, ferretería y servicios legales.',
    buttonText: 'Activar Campaña de Confianza',
    highlightedTitle: 'Validación de Comunidad',
    highlightedContent: [
      'El contenido auténtico en condominios genera una confianza del 75% más que un folleto tradicional.',
      'Tu marca deja de ser un gasto y se convierte en una inversión para la comunidad.',
      'Ideal para quienes quieren posicionarse como la solución que las juntas de condominio recomiendan.',
    ],
    highlightedButtonText: 'Activar Campaña de Confianza',
  },
  {
    title: 'Sponsorship: El ABC del Condominio',
    monthlyPrice: 100,
    annualPrice: '280 USD',
    duration: 'Por segmento',
    features: [
      'Integración de marca en la sección de asesoría legal o técnica.',
      'Mención de beneficios del producto como facilitador de la convivencia.',
      'Presencia visual del logo y producto en el set (Radio Visual).',
    ],
    idealFor: 'Bancos (cuentas de condominio), seguros, empresas de limpieza y software de administración.',
    buttonText: 'Patrocinar Segmento',
    highlightedTitle: 'Para quién está dirigido',
    highlightedContent: [
      'Bancos y entidades que ofrecen cuentas de condominio: tu producto se explica donde se toman las decisiones.',
      'Seguros, empresas de limpieza y software de administración que buscan credibilidad frente a síndicos y juntas.',
      'Marcas que quieren ser la opción natural cuando el condominio necesita un proveedor de confianza.',
    ],
    highlightedButtonText: 'Patrocinar Segmento',
  },
  {
    title: 'Interactive Community Push',
    monthlyPrice: 60,
    annualPrice: '170 USD',
    duration: 'Por campaña',
    features: [
      'Encuestas y sesiones de preguntas y respuestas en Instagram Stories.',
      'Fomento del debate sobre mejoras en edificios vinculadas a la marca.',
      'Call to action con link directo a cotizaciones o catálogos.',
    ],
    idealFor: 'Proveedores que buscan captar leads directos de Juntas de Condominio.',
    buttonText: 'Generar Leads',
    highlightedTitle: 'Para quién está dirigido',
    highlightedContent: [
      'Proveedores que buscan leads calificados: síndicos, administradores y miembros de juntas que ya están pensando en mejoras.',
      'Perfecto para campañas por tiempo limitado: lanzamientos, promociones o necesidad de llenar agenda de cotizaciones.',
      'Quienes quieren medir resultados con enlaces directos a WhatsApp, formularios o catálogos.',
    ],
    highlightedButtonText: 'Generar Leads',
  },
  {
    title: 'Socio Estratégico del Condominio',
    monthlyPrice: '250 USD',
    annualPrice: '700 USD',
    duration: 'Por mes',
    features: [
      'Mención de apertura y cierre: "Este programa llega a ustedes gracias a..."',
      'Banner fijo (Lower Third) con logo de la marca durante toda la transmisión en streaming.',
      'Rotación de cuñas comerciales de 30 seg en cada bloque del programa.',
      'Exclusividad de rubro (Solo una marca por categoría en el programa).',
    ],
    idealFor: 'Empresas líderes en seguros, banca corporativa o servicios de ingeniería a gran escala.',
    buttonText: 'Ser Patrocinante Principal',
    highlightedTitle: 'Para quién está dirigido',
    highlightedContent: [
      'Empresas líderes en seguros, banca corporativa o servicios de ingeniería que buscan visibilidad recurrente y exclusiva.',
      'Marcas que quieren asociar su nombre al programa de referencia en condominios, no solo a un segmento puntual.',
      'Ideal para presupuestos que priorizan impacto y recordación a lo largo de todo el programa.',
    ],
    highlightedButtonText: 'Ser Patrocinante Principal',
  },
  {
    title: 'Expert Talk: Soluciones en Vivo',
    monthlyPrice: '180 USD',
    annualPrice: '500 USD',
    duration: 'Por entrevista',
    features: [
      'Segmento de 15 minutos de entrevista central con el Dr. Julio César López Galea.',
      'Enfoque educativo-comercial: Cómo tu producto resuelve un vacío legal o técnico.',
      'Corte del video de la entrevista optimizado para YouTube y Redes Sociales.',
      'Derecho a usar el sello "Visto en Dr. Condominio Radio" en tus comunicaciones.',
    ],
    idealFor: 'CEOs de administradoras, peritos, especialistas en seguridad o nuevos productos tecnológicos.',
    buttonText: 'Agendar Entrevista',
    highlightedTitle: 'Para quién está dirigido',
    highlightedContent: [
      'CEOs de administradoras, peritos y especialistas en seguridad que quieren mostrar autoridad y diferenciarse.',
      'Marcas con productos o servicios técnicos o legales que necesitan explicarse en un contexto de confianza.',
      'Quienes buscan contenido reutilizable: la entrevista sirve para web, redes y material de ventas.',
    ],
    highlightedButtonText: 'Agendar Entrevista',
  },
  {
    title: 'Branded Content Editorial',
    monthlyPrice: '40 USD',
    annualPrice: '110 USD',
    duration: 'Por post',
    features: [
      'Artículo especializado en tnonetwork.com (Sección TNO Digest).',
      'Redacción profesional enfocada en soluciones para la comunidad.',
      'Incluye enlaces (Backlinks) directos a tu página web o WhatsApp de ventas.',
      'Permanencia garantizada: Tu marca aparecerá en las búsquedas de Google sobre condominios.',
    ],
    idealFor: 'Proveedores que necesitan explicar a fondo sus servicios (ej. nuevos sistemas de impermeabilización).',
    buttonText: 'Publicar Artículo',
    highlightedTitle: 'Para quién está dirigido',
    highlightedContent: [
      'Proveedores que necesitan explicar a fondo sus servicios: impermeabilización, tecnología, seguridad, legal.',
      'Marcas que invierten en SEO y quieren aparecer cuando se buscan soluciones para condominios.',
      'Ideal para lanzamientos o productos complejos que se venden mejor con un artículo que con un anuncio.',
    ],
    highlightedButtonText: 'Publicar Artículo',
  },
];

export default optionsData;
